module.exports = __webpack_public_path__ + "static/img/4areaA_15.02de988.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/4areaA_15.png
// module id = 1028
// module chunks = 1